/**
 * Created by sung.hwang on 5/26/17.
 */
import { SIGN_IN_SUCCESS } from '@zocdoc-frontend-common/components-sign-in-form';
import { CREATE_ACCOUNT_SUCCESS } from '@zocdoc/components/src/CreateAccountForm';
import { SchedulingActions } from '../Booking/actions/SchedulingActions';
import loadBranchApi, {
    getIdsFromCookies,
} from '@zocdoc-frontend-common/utils-branch/loadBranchApi';
import { BookingCompletePageActions } from '../Booking/pages/BookingComplete/BookingCompletePageActions';
import { isBookingStateForPrivateWhiteLabel } from '../utils/isPrivateWhiteLabel';

/**
 * branch.track('pageview') enables showing banner instantly
 * on the same single page app.
 * This is conceptually different from the custom events we want to track.
 * */
const showBanner = () => window.branch.track('pageview');

export const trackOnBranch = async action => {
    if (typeof window !== 'undefined') {
        if (window.branch) {
            window.branch.setBranchViewData({
                data: getIdsFromCookies(),
            });
        }
        await loadBranchApi({ no_journeys: true });
        let branchEvent;
        switch (action.type) {
            case SIGN_IN_SUCCESS: {
                branchEvent = 'WebSignedIn';
                break;
            }
            case CREATE_ACCOUNT_SUCCESS: {
                branchEvent = 'WebCreatedAccount';
                break;
            }
            case SchedulingActions.SUBMIT_BOOKING_SUCCESS: {
                branchEvent = 'WebBooked';
                break;
            }
            case BookingCompletePageActions.TRACK_BOOKED_APPT: {
                showBanner();
                break;
            }
            // no default
        }

        if (branchEvent) {
            window.branch.track(branchEvent);
        }
    }
};

/**
 * Condition that we want to do anything with branch.io. (track custom event, show banner etc.)
 * If your app needs to use branch banner, add the appropriate condition here.
 * @param state
 * @returns {*|boolean}
 */
const useBranch = state => {
    return (
        state.bookingInit &&
        !state.bookingInit.whiteLabelName &&
        !isBookingStateForPrivateWhiteLabel(state)
    );
};

export const branchTrackerMiddleware = store => next => action => {
    const state = store.getState();
    if (useBranch(state)) {
        trackOnBranch(action);
    }
    return next(action);
};
